const CREATE_GROUP_SUCCESSFUL = 'Create group successful'

export default {
  CREATE_GROUP_SUCCESSFUL
}



// WEBPACK FOOTER //
// ./src/app/reducers/constants/groupConstants.js